import React, { useState } from 'react';
import WizardTabs from './WizardTabs';

const ManagedWizardTabs = ({ tabsList, invalidTabs, tabsContainerClass, tabButton = null, dirtyTabs }) => {
    const [selectedTab, setSelectedTab] = useState(0);

    return (
        <>
            <WizardTabs
                availableTabs={tabsList.map((tab) => tab.header)}
                selectedTab={selectedTab}
                setSelectedTab={setSelectedTab}
                tabButton={tabButton}
                invalidTabs={invalidTabs}
                dirtyTabs={dirtyTabs}
            />
            <div className={tabsContainerClass}>{tabsList[selectedTab] && tabsList[selectedTab].component}</div>
        </>
    );
};

export default ManagedWizardTabs;
